import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/print-test")({
  component: PrintTestPage,
});

const sampleEntries = [
  {
    date: "2026-03-01",
    time: "08:14",
    reading: 3.2,
    recordedBy: "Sarah Henderson",
  },
  {
    date: "2026-03-01",
    time: "13:02",
    reading: 4.1,
    recordedBy: "Sarah Henderson",
  },
  {
    date: "2026-03-02",
    time: "08:08",
    reading: 2.9,
    recordedBy: "Daniel Okafor",
  },
  {
    date: "2026-03-02",
    time: "13:11",
    reading: 3.6,
    recordedBy: "Daniel Okafor",
  },
  {
    date: "2026-03-03",
    time: "08:21",
    reading: 3.4,
    recordedBy: "Sarah Henderson",
  },
  {
    date: "2026-03-03",
    time: "13:05",
    reading: 4.0,
    recordedBy: "Sarah Henderson",
  },
  { date: "2026-03-04", time: "08:17", reading: 3.1, recordedBy: "Mei Tanaka" },
  { date: "2026-03-04", time: "13:09", reading: 3.8, recordedBy: "Mei Tanaka" },
];

function PrintTestPage() {
  const generatedAt = new Date().toLocaleString("en-GB", {
    dateStyle: "long",
    timeStyle: "short",
  });

  return (
    <div className="pdf-ready bg-white text-black">
      <style>{`
        @page { size: A4; margin: 18mm 16mm; }
        @media print {
          html, body { background: white !important; }
        }
      `}</style>

      <main className="mx-auto max-w-[170mm] p-8 font-sans">
        <header className="border-b border-black pb-4">
          <div className="flex items-baseline justify-between">
            <h1 className="text-2xl font-semibold">
              Fridge/Freezer Temperature Log
            </h1>
            <span className="text-sm">March 2026</span>
          </div>
          <p className="mt-1 text-sm">Sunny Days Nursery — Kitchen unit</p>
        </header>

        <table className="mt-6 w-full border-collapse text-sm">
          <thead>
            <tr className="border-b border-black">
              <th className="py-2 text-left">Date</th>
              <th className="py-2 text-left">Time</th>
              <th className="py-2 text-left">Reading (°C)</th>
              <th className="py-2 text-left">Recorded by</th>
            </tr>
          </thead>
          <tbody>
            {sampleEntries.map((entry, i) => (
              <tr key={i} className="border-b border-neutral-300">
                <td className="py-2">{entry.date}</td>
                <td className="py-2">{entry.time}</td>
                <td className="py-2">{entry.reading.toFixed(1)}</td>
                <td className="py-2">{entry.recordedBy}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <footer className="mt-8 flex items-baseline justify-between border-t border-black pt-3 text-xs">
          <span>Generated {generatedAt}</span>
          <span>Page 1 of 1</span>
        </footer>
      </main>
    </div>
  );
}
